import TypesMultiselectInput from './TypesMultiselectInput';

export default TypesMultiselectInput;